import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import axios from "axios";
import NavBar from "./Navbar";
import Loader from "./Loader";
import { TailSpin } from "react-loader-spinner";
import TopNavBar from "./TopNavbar";
import Pagination from "./Pagination";
import "../styles/AddEmployee.css";
import "../styles/UserProfile.css";
import "../styles/UserDetail.css";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import DefaultEmployeeProfile from "../images/DefaultEmployeeProfile.svg";
import generateInvoiceInActive from "../images/generateInvoice.svg";
import emailIcon from "../images/emailIcon.svg";
import employeeIdIcon from "../images/employeeIdIcon.svg";
import nameIcon from "../images/nameIcon.svg";
import payrateIcon from "../images/payrateIcon.svg";
import { useAuth } from "../auth/auth";
import { fetchInvoices, fetchInvoiceCount } from "../services/InvoiceService";
import {
  deniedActionClass,
  usePermissionGuard,
} from "../hooks/usePermissionGuard";
import { PERMISSIONS, canCreatePayslip } from "../utils/rbac";
const apiUrl = process.env.REACT_APP_API_URL;

function UserProfile() {
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state;
  //console.log('userEmail ',userEmail)
  const [employeeData, setEmployeeData] = useState(null);
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(15);
  const [count, setCount] = useState(0);
  const [isYtdModalOpen, setIsYtdModalOpen] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [editedYtdAmount, setEditedYtdAmount] = useState("");
  const [currentInvoiceData, setCurrentInvoiceData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const { guardAction, PermissionDialog, isAllowed } = usePermissionGuard();
  const canManageYtd = isAllowed(PERMISSIONS.MANAGE_YTD);
  useAuth();

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    // Define the async function to fetch invoices
    fetchEmployeeDetails(id);
    const fetchInvoicesAndCount = async () => {
      try {
        const invoices = await fetchInvoices(
          currentPage,
          pageSize,
          "user",
          id
        );
        setInvoices(invoices);

        // Fetch and set count
        const userCount = await fetchInvoiceCount("user", id);
        setCount(userCount);
      } catch (error) {
        // Handle errors if needed
        console.error("Error fetching invoices:", error);
      }
    };

    // Call the function when currentPage changes
    fetchInvoicesAndCount();
  }, [currentPage, id]);

  // useEffect(() => {
  //   fetchEmployeeDetails(userEmail);
  // }, [userEmail]);

  const fetchEmployeeDetails = async (id) => {
    try {
      const response = await axios.post(`${apiUrl}/getEmployeeDetail`, {
        id,
      });
      if (response.data && response.data.data) {
        setEmployeeData(response.data.data);

        // formik.setValues(response.data.data);
          formik.setValues({
          ...response.data.data,
          selectedPaymentMethod: response.data.data.payment_method || "", // ✅ set it manually
        });
        setImageUrl(response.data.data.image);

        // const invoiceResponse = await axios.post(`${apiUrl}/getUserInvoice`, {
        //   email: userEmail, // Assuming userEmail is defined in your component state
        // });
        // //console.log("response invoice :- ", invoiceResponse.data.data);
        // setInvoices(invoiceResponse.data.data);
        // setCount(invoiceResponse.data.count);
        // setCount(20);

        // Fetch Invoices
        const invoices = await fetchInvoices(
          currentPage,
          pageSize,
          "user",
          id
        );

        setInvoices(invoices);

        // Fetch and set count
        const userCount = await fetchInvoiceCount("user", id);
        setCount(userCount);
      }
    } catch (error) {
      //console.error("Error:", error);
    }
  };

  function formatInvoiceAdditions(additions) {
    const numericValue = Number(additions);

    if (isNaN(numericValue) || numericValue % 1 !== 0) {
      // Check if it's a decimal
      const formattedValue = numericValue.toFixed(2); // Ensure 2 digits after the decimal point
      return formattedValue;
    } else {
      // If it's an integer, add .00 to make it a decimal with 2 digits after the decimal point
      return additions + ".00";
    }
  }

  const showMessage = (msg) => {
    setMessage(msg);
    setTimeout(() => {
      setMessage(null);
    }, 3000);
  };

  const handleEditYtdSubmit = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(`${apiUrl}/updateYTDFinal`, {
        invoiceId: selectedInvoiceId,
        newYTDFinal: parseFloat(editedYtdAmount),
      });
      const data = response.data;
      if (response.status === 200 && data.status === 1) {
        setIsYtdModalOpen(false);
        showMessage("YTD Amount updated successfully");
        // Refresh invoices
        const invoices = await fetchInvoices(currentPage, pageSize, "user", id);
        setInvoices(invoices);
      } else {
        showMessage("Error: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      showMessage("An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      payRate: "",
      tertiaryPayRate: "",
      selectedPaymentMethod: "",
      //image: '',
    },
    onSubmit: async (values) => {
      try {
        let imageUrl = values.image; // Retrieve the existing image URL from the form values

        if (image) {
          const timestamp = Date.now(); // Generate a unique timestamp
          const imageName = `${timestamp}_${image.name}`; // Concatenate timestamp with image name

          const storageRef = firebase.storage().ref().child("employees");
          const imageRef = storageRef.child(imageName);
          await imageRef.put(image);
          imageUrl = await imageRef.getDownloadURL();
          //console.log("imageUrl", imageUrl);
          values.image = imageUrl; // Update form values with the new image URL
        }

        const response = await axios.post(`${apiUrl}/editEmployee`, values);
        if (response.data && response.data.status === 1) {
          // Show success message
          window.alert(response.data.message);
        } else {
          // Show error message
          window.alert("Error: " + response.data.message);
        }
      } catch (error) {
        //console.error("Error:", error);
      }
    },
  });

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setImageUrl(URL.createObjectURL(e.target.files[0])); // Display the selected image instantly

      // Set the data-name attribute to display the file name
      e.target.setAttribute("data-name", e.target.files[0].name);
    }
  };

  // if (employeeData === null) {
  //   return <Loader />;
  // }
  return (
    <div className="feedback-parent-container">
      <NavBar />
      <TopNavBar />
      <PermissionDialog />
      {message && (
        <div className="custom-modal">
          <div className="modal-content">{message}</div>
        </div>
      )}
      {isYtdModalOpen && currentInvoiceData && (
        <div className="custom-modal">
          <div className="modal-content-ytd" style={{ minWidth: "400px" }}>
            <h3 style={{ marginBottom: "16px" }}>Edit YTD Amount</h3>
            
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold", fontSize: "15px" }}>
              YTD Amount:
            </label>
            <input
              type="number"
              step="0.01"
              value={editedYtdAmount}
              onChange={(e) => setEditedYtdAmount(e.target.value)}
              placeholder="Enter YTD amount"
              style={{ width: "94%", padding: "10px", marginBottom: "16px", fontSize: "15px", border: "2px solid #2E8056" }}
            />
            
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                className="edit-ytd-submit"
                onClick={() => setIsYtdModalOpen(false)}
              >
                Cancel
              </button>
              <button className="edit-ytd-submit" onClick={handleEditYtdSubmit}>
                Update
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="container-userProfile">
        <div className="admin-header-user-profile">
          <div className="left-section">
            <h1 className="admin-card-title">
              <Link
                to="/manageEmployee"
                className="admin-card-title-link custom-link"
              >
                <span className="fade-text">Manage Employee</span>
              </Link>
              {" > "}
              <span className="admin-card-title-span top-heading-employee-details">
                Employee Details
              </span>
            </h1>
          </div>
          <div className=" user-profile-generte-invoice-right-section">
            <Link
              to="/generateInvoice"
              state={formik.values.id}
              className={`add-user-link custom-generate-invoice ${deniedActionClass(canCreatePayslip())}`}
              onClick={(e) => {
                e.preventDefault();
                guardAction(PERMISSIONS.CREATE_PAYSLIP, "generate payslip", () => {
                  navigate("/generateInvoice", { state: formik.values.id });
                });
              }}
            >
              <div className="add-user-container">
                <img
                  src={generateInvoiceInActive}
                  alt="Manage employee Icon"
                  className="addEmployeeIcon"
                />
                <span className="admin-card-title-span"> Generate Payslip</span>
              </div>
            </Link>
          </div>
        </div>
        {employeeData === null && (
          <div className="spinner-container">
            <TailSpin
              type="TailSpin"
              color="rgba(135, 106, 237, 1)"
              height={70}
              width={70}
              timeout={5000}
            />
          </div>
        )}
        {employeeData !== null && (
          <div className="card-addEmployee">
            <div className="card-body-addEmployee">
              <form className="form-container-addEmployee">
                <div className="add-employee-left-section">
                  <div className="image-section">
                    <div className="profile-image-container">
                      {!imageUrl && ( // If imageUrl is not available
                        <div className="">
                          <img
                            src={DefaultEmployeeProfile}
                            alt="Default Employee Image"
                          />
                        </div>
                      )}
                      {imageUrl && (
                        <div className="">
                          <img src={imageUrl} alt="Employee Image" />
                        </div>
                      )}
                      <div className="input-container-addEmployee"></div>
                    </div>
                  </div>
                </div>
                <div className="form-group-addEmployee form-right-section">
                  <label className="label-personal-data">Personal Data</label>
                  <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img className="email-icon" src={nameIcon} alt="icon" />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="text"
                        name="name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                        placeholder="Name"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img
                        className="email-icon"
                        src={employeeIdIcon}
                        alt="icon"
                      />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="text"
                        name="id"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.id}
                        placeholder="Employee Id"
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img className="email-icon" src={emailIcon} alt="icon" />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="email"
                        name="email"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                        placeholder="Email Address"
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img
                        className="email-icon"
                        src={payrateIcon}
                        alt="icon"
                      />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="text"
                        name="payRate"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={`${formik.values.payRate} ($/hr)`}
                        placeholder="Pay Rate ($/hr)"
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img
                        className="email-icon"
                        src={payrateIcon}
                        alt="icon"
                      />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="text"
                        name="secondaryPayRate"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={`${formik.values.secondaryPayRate} ($/hr)`}
                        placeholder="Secondary Pay Rate ($/hr)"
                        readOnly
                      />
                    </div>
                     
                  </div>
                  <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img
                        className="email-icon"
                        src={payrateIcon}
                        alt="icon"
                      />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="text"
                        name="tertiaryPayRate"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={`${
                          formik.values.tertiaryPayRate !== undefined &&
                          formik.values.tertiaryPayRate !== null
                            ? formik.values.tertiaryPayRate
                            : ""
                        } ($/hr)`}
                        placeholder="Tertiary Pay Rate ($/hr)"
                        readOnly
                      />
                    </div>
                  </div>
                   <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img
                        className="email-icon"
                        src={payrateIcon}
                        alt="icon"
                      />
                    </div>
                   <div className="form-input-container">
                      <input
                        type="text"
                        name="selectedPaymentMethod"
                        value={`${formik.values.selectedPaymentMethod}`}
                        placeholder="Payment method"
                        readOnly
                      />
                    </div>
                    </div>

                  <div className="input-container-addEmployee input-container-box input-container-box--employee-eligibility">
                    <div
                      style={{
                        display: "flex",
                        gap: "24px",
                        alignItems: "center",
                      }}
                    >
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontFamily: "Montserrat",
                          cursor: "default",
                        }}
                      >
                        <input
                          type="checkbox"
                          className="user-profile-eligibility-checkbox"
                          checked={
                            employeeData?.isPayslipEligible !== undefined &&
                            employeeData?.isPayslipEligible !== null
                              ? Number(employeeData.isPayslipEligible) === 1
                              : true
                          }
                          onChange={() => {}}
                          tabIndex={-1}
                          aria-label="Payslip eligible (view only)"
                        />
                        Payslip Eligible
                      </label>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontFamily: "Montserrat",
                          cursor: "default",
                        }}
                      >
                        <input
                          type="checkbox"
                          className="user-profile-eligibility-checkbox"
                          checked={
                            employeeData?.isInvoiceEligible !== undefined &&
                            employeeData?.isInvoiceEligible !== null
                              ? Number(employeeData.isInvoiceEligible) === 1
                              : true
                          }
                          onChange={() => {}}
                          tabIndex={-1}
                          aria-label="Invoice eligible (view only)"
                        />
                        Invoice Eligible
                      </label>
                    </div>
                  </div>

                  {/* <div className="form-group-addEmployee form-right-section">
                  <label className="label-addEmployee">Image:</label>
                  <div className="employee-image-container">
                    <div className="input-container-addEmployee">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                    </div>
                    {imageUrl && (
                      <div className="input-container-addEmployee">
                        <img src={imageUrl} alt="Employee Image" />
                      </div>
                    )}
                  </div>
                </div> */}
                  <div className="btn-addEmployee">
                    <Link to="/editEmployee" state={formik.values.id}>
                      <button type="submit" className="add-employee-submit">
                        Update Details
                      </button>
                    </Link>
                  </div>
                </div>
              </form>
            </div>
            <div className="user-profile-inner-div">
              <div>
                <h3 className="gold-text invoice-gold-text">Payslip</h3>
              </div>
              <div className="user-table-wrapper">
                <table className="invoice-table even-user-table userHeaderNew">
                  <thead>
                    <tr>
                      <th>Pay Period</th>
                      <th>Pay Rate($)</th>
                      <th>Hours</th>
                      <th>Additions($)</th>
                      <th>Deductions($)</th>
                      <th>Amount($)</th>
                      <th>YTD Amount($)</th>
                      {/* <th>Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {invoices.map((invoice, index) => (
                      <tr key={invoice.id}>
                        <td>{invoice.payPeriod}</td>
                        <td>${formatInvoiceAdditions(invoice.payRate)}</td>
                        <td>
                          {/* {invoice.hours}. {invoice.minutes}hr */}
                          {invoice.hours}:
                          {invoice.minutes.toString().padStart(2, "0")}
                        </td>
                        <td>{formatInvoiceAdditions(invoice.Additions)}</td>
                        <td>{formatInvoiceAdditions(invoice.Deductions)}</td>
                        <td>{formatInvoiceAdditions(invoice.Amount)}</td>
                        <td>
                          <button
                            onClick={() => {
                              guardAction(
                                PERMISSIONS.MANAGE_YTD,
                                "edit YTD amount",
                                () => {
                                  setIsYtdModalOpen(true);
                                  setSelectedInvoiceId(invoice.id);
                                  setCurrentInvoiceData(invoice);
                                  setEditedYtdAmount(
                                    invoice.YTDFinal || invoice.YTDAmount || 0,
                                  );
                                },
                              );
                            }}
                            style={{
                              background: "none",
                              border: "none",
                              marginLeft: "8px",
                              cursor: "pointer",
                            }}
                            className={deniedActionClass(canManageYtd)}
                            title="Edit YTD Amount"
                          >
                            ✏️
                          </button>
                          {formatInvoiceAdditions(invoice.YTDFinal || invoice.YTDAmount)}
                        </td>
                        {/* <td style={{ width: "95px" }}> */}
                          {/* Action buttons can go here if needed */}
                        {/* </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {count !== undefined && count > 0 ? (
                <Pagination
                  currentPage={currentPage}
                  pageSize={pageSize}
                  totalUsers={count}
                  onPageChange={handlePageChange}
                />
              ) : null}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserProfile;
